import { Injectable, inject, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { DwSystemHttpErrorHandler } from './system-error';
import { Body } from '@angular/http/src/body';
import { GetloadingService } from './getloading.service';

export interface IDwRequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  observe?: 'body' | 'events' | 'response';
  params?: HttpParams | { [param: string]: string | string[] };
  reportProgress?: boolean;
  body?: any;
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  withCredentials?: boolean;
}


@Injectable()
export abstract class DwHttpClient {
  protected systemHttpError: DwSystemHttpErrorHandler;
  protected http: HttpClient;
  protected api = '';
  private throwawayHeader: { [header: string]: string | string[] };
  public load:GetloadingService;

  public constructor() {
    this.systemHttpError = inject(DwSystemHttpErrorHandler);
    this.http = inject(HttpClient);
    // this.initialize();
    this.load = inject(GetloadingService);
  }

  // protected abstract initialize(): void;

  protected errorHandler(error: HttpErrorResponse): void { }
  protected responseIntercept(body: any): any {
    return body;
  }

  protected get defaultHeaders(): { [header: string]: string | string[] } {
    return {};
  }

  protected get defaultParams(): { [param: string]: string } {
    return {};
  }

  public setThrowawayHeader(header: { [header: string]: string | string[] }): void {
    this.throwawayHeader = header;
  }

  protected addDefaultOption(options?: IDwRequestOptions): any {
    const localOptions = options || {};

    let headers: HttpHeaders;
    if (localOptions.headers instanceof HttpHeaders) {
      headers = localOptions.headers;
    } else {
      headers = new HttpHeaders(localOptions.headers);
    }

    const localHeaders = this.throwawayHeader || this.defaultHeaders;
    this.throwawayHeader = undefined;

    headers = Object.keys(localHeaders)
      .reduce((acc, name) => (acc.has(name)) ? acc : acc.set(name, localHeaders[name]), headers);

    let params: HttpParams;
    if (!!localOptions.params) {
      if (localOptions.params instanceof HttpParams) {
        params = localOptions.params;
      } else {
        params = new HttpParams({ fromObject: localOptions.params });
      }
    }

    params = Object.keys(this.defaultParams)
      .reduce((acc, name) => (acc.has(name)) ? acc : acc.set(name, this.defaultParams[name]), params);


    return {
      headers,
      observe: localOptions.observe,
      params,
      body: localOptions.body,
      reportProgress: localOptions.reportProgress,
      responseType: localOptions.responseType,
      withCredentials: localOptions.withCredentials
    };
  }

  private requestProcess(request: Observable<any>): Observable<any> {
    return request.pipe(
      tap(
        response => response,
        error => {
          this.systemHttpError.handlerError(error);
          this.errorHandler(error);
        }
      ),
      map(response => this.responseIntercept(response))
    );
  }

  public request<T>(method: string, url: string, options?: IDwRequestOptions): Observable<any> {
    const requestOptions = this.addDefaultOption(options);
    const request = this.http.request<T>(method, this.api + url, requestOptions);
    return this.requestProcess(request);
  }

  public get<T>(url: string, options?: IDwRequestOptions): Observable<any> {
    const requestOptions = this.addDefaultOption(options);
    const request = this.http.get<T>(this.api + url, requestOptions);
    return this.requestProcess(request);
  }

  public post<T>(url: string, body: Object, options?: IDwRequestOptions): Observable<any> {

    console.log(this.load,'加载')
    // this.load.getMask('',true)
    const requestOptions = this.addDefaultOption(options);
    const request = this.http.post<T>(this.api + url, body, requestOptions);
    return this.requestProcess(request);
  }

  public put<T>(url: string, body: Object, options?: IDwRequestOptions): Observable<any> {
    const requestOptions = this.addDefaultOption(options);
    const request = this.http.put<T>(this.api + url, body, requestOptions);
    return this.requestProcess(request);
  }

  public delete<T>(url: string, options: IDwRequestOptions): Observable<any> {
    const requestOptions = this.addDefaultOption(options);
    const request = this.http.delete<T>(this.api + url, requestOptions);
    return this.requestProcess(request);
  }
}
